import React from 'react';
import './NotFound.scss';
import Logo from '../../assets/Logo.svg';
import NotFoundImage from '../../assets/not-found.svg';

export const NotFound = () => (
    <div className="not-found-container">
        <div className="not-found-content">
            <div className="logo-container">
                <img src={Logo} alt="Kan Logo" className="logo" />
            </div>
            <div className="not-found-image-container">
                <img src={NotFoundImage} alt="Page Not Found" className="not-found-image" />
            </div>

            <h1> אופס! הדף שחיפשת לא קיים.</h1>
            <p>יש להיכנס עם הקישור שקיבלת ו/או ליצור קשר עם הגורם שהפנה אותך.</p>

            {/* <div className="example-section">
                <strong>דוגמה לקישור תקין:</strong>
                <code>https://forms.kan.org.il/new-application/[APPLICATION_ID]</code>
            </div> */}

            {/* <button onClick={() => (window.location.href = '/')} className="home-button">
                חזור לדף הבית
            </button> */}
        </div>
    </div>
);
